import isNil from 'lodash/isNil'
import { css } from 'styled-components'
import { color as themeColor, fontSize, inputSize, theme } from 'utils'

import { InputSizeType, ThemePropsType as _T } from '../types'
import { PropsType as _P } from '.'
import variant from './variant'

type PropsType = {
  size?: InputSizeType
  variant: keyof typeof variant
}

type SPropsType = _P & _T & { error?: string }

type ColorProps = {
  error?: string
  variant: keyof typeof variant
} & _T
export const color = (idx: number) => (props: ColorProps) => {
  const name = variant[props.variant][idx]

  if (!isNil(props.error) && (idx === 3 || idx === 5 || idx === 4)) {
    return theme('dangerColor')(props)
  }

  return themeColor(name)(props)
}

export const label = css`
  color: ${color(5)};
  font-size: ${fontSize('xs')};
  font-weight: 600;
`

export const active = css<ColorProps & { disabled?: boolean }>`
  box-shadow: none;
  background: ${color(2)};
  color: ${color(8)};
  border-color: ${color(4)};

  &::placeholder {
    color: ${color(10)};
  }

  + svg {
    fill: ${(props) => (props.disabled === true ? color(7)(props) : color(8)(props))};
  }
`

export const checkbox = css`
  height: 1.5rem;
  padding-left: 2rem;

  &::before {
    background-color: ${color(11)};
    border-color: ${color(13)};
    height: 1.5rem;
    width: 1.5rem;
    top: 0;
    border-width: 2px;
  }

  &::after {
    border-color: ${themeColor('white')};
    height: 8px;
    left: 6px;
    margin-top: -6px;
    width: 14px;
  }
`

export const checked = css`
  &::before {
    background-color: ${color(12)};
    border-color: ${color(14)};
  }
`

type InputCSSProps = PropsType & Pick<_P, 'renderSuffix'> & Pick<_P, 'type'>
export const input = css<InputCSSProps>`
  color: ${color(6)};
  height: ${(props) =>
    ['checkbox', 'radio'].includes(props.type ?? '') ? 'auto' : inputSize(props.size ?? 'md')};
  background: ${color(0)};
  border-color: ${color(3)};
  ${({ renderSuffix }) => (renderSuffix ? 'padding-right: 3rem' : '')};

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &::placeholder {
    font-size: ${() => fontSize('md')};
    color: ${color(9)};
  }

  &:disabled {
    color: ${color(7)};
    background: ${color(1)};
    border-color: ${color(3)};

    &::placeholder {
      color: ${color(7)};
    }
  }
`

export const span = css`
  position: absolute;
  right: 1rem;
  bottom: 0.875rem;
  color: ${color(6)};
  user-select: none;
`

const suffixPosition = css`
  position: absolute;
  right: 1rem;
  bottom: 1rem;
`

export const svg = css`
  ${suffixPosition};
  fill: ${(props: SPropsType) => (props.disabled === true ? color(7)(props) : color(6)(props))};

  &:hover {
    fill: ${(props: SPropsType) => (props.disabled === true ? color(7)(props) : color(6)(props))};
  }
`

export const loader = css`
  ${suffixPosition};

  div {
    background: ${(props: SPropsType) =>
      props.disabled === true ? color(7)(props) : color(6)(props)};
  }
`
